// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1kuWW","dragIcon":"Choice_dragIcon__ryT8x","left":"Choice_left__3Skec","input":"Choice_input__vIpJe"};